module.exports = __webpack_public_path__ + "media/images/pages/icn_star-2d56a9337ef66d5900cc2435122d94cf.svg";